import { render } from "./Control_Svg.vue?vue&type=template&id=47035894"
import script from "./Control_Svg.vue?vue&type=script&lang=js"
export * from "./Control_Svg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../ag-v3-trion/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__